/*
 * "Gelince Haber Ver" ve "Fiyat Alarmı" (Holly Product Alert embed'i yerine Comnexus).
 *   data-button_type="InStock"  → LET_ME_KNOW (stok gelince haber ver)
 *   data-button_type="Discount" → PRICE_DROP_NOTIFY (fiyat düşünce haber ver)
 *
 * Çağrı yerleri değişmesin diye global fonksiyon adı korunuyor:
 *   onclick="openHollyNotificationStockOutModal(this)"
 * Buton nitelikleri: data-product_id, data-variant_id, data-button_type ("InStock").
 *
 * Üye: kayıt müşterinin e-postasıyla doğrudan açılır, sonuç modalda gösterilir.
 * Misafir: girişe yönlendirilir; talep sessionStorage'da tutulur ve aynı sayfaya
 * giriş yapmış olarak dönüldüğünde otomatik tamamlanır. (Misafirden e-posta almak
 * KVKK aydınlatma metni gerektirir; geçiş planı CX-08 madde 3.)
 *
 * Metinler ve logo: window.theme.stockNotify (layout/theme.liquid).
 * Bağımlılık: assets/comnexus-api.js.
 */
(function () {
  'use strict';

  var PENDING_KEY = 'stock_notify_pending_v1';
  var PENDING_TTL_MS = 30 * 60 * 1000;
  var modal = null;

  // Fiyat alarmı metinleri. Sunucu Türkçe mesaj dönerse (Accept-Language: tr) o gösterilir.
  var PRICE_TEXTS = {
    title: 'Fiyat Alarmı',
    success: 'Ürünün fiyatı düştüğünde sizi e-posta yoluyla bilgilendireceğiz.',
    already: 'Bu ürün için fiyat alarmınız zaten var.',
    error: 'İşlem sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.'
  };

  function isPriceType(type) {
    return type === 'Discount';
  }

  function texts(type) {
    var t = (window.theme && window.theme.stockNotify) || {};
    if (isPriceType(type)) {
      return {
        title: PRICE_TEXTS.title,
        success: PRICE_TEXTS.success,
        already: PRICE_TEXTS.already,
        error: PRICE_TEXTS.error,
        close: t.close || 'Kapat',
        logo: t.logo || ''
      };
    }
    return {
      title: t.title || 'Stok Güncellenme Bildirimi',
      success: t.success || 'Ürün stoklarımıza yeniden girdiğinde sizi e-posta yoluyla bilgilendireceğiz.',
      already: t.already || 'Daha önceden bu ürün için bildirim kaydı oluşturulmuş!',
      error: t.error || 'İşlem sırasında bir hata oluştu. Lütfen daha sonra tekrar deneyiniz.',
      close: t.close || 'Kapat',
      logo: t.logo || ''
    };
  }

  function identity() {
    var id = window.theme && window.theme.customerIdentity;
    return id && id.id && id.email ? id : null;
  }

  /* ---------------------------------------------------------------------- */
  /* Modal                                                                  */
  /* ---------------------------------------------------------------------- */

  function injectStyles() {
    if (document.getElementById('stock-notify-styles')) return;
    var style = document.createElement('style');
    style.id = 'stock-notify-styles';
    style.textContent =
      '.stock-notify{position:fixed;inset:0;z-index:999999;display:none;align-items:center;justify-content:center;padding:16px;background:rgba(0,0,0,.5)}' +
      '.stock-notify.is-open{display:flex}' +
      '.stock-notify__box{position:relative;width:100%;max-width:440px;background:#fff;border-radius:8px;padding:28px 24px 24px;text-align:center;box-shadow:0 10px 40px rgba(0,0,0,.2)}' +
      '.stock-notify__close{position:absolute;top:10px;right:10px;width:36px;height:36px;border:0;background:none;cursor:pointer;font-size:24px;line-height:1;color:#383838}' +
      '.stock-notify__logo{display:block;margin:0 auto 16px;max-width:120px;height:auto}' +
      '.stock-notify__title{margin:0 0 12px;font-size:18px;font-weight:700}' +
      '.stock-notify__body{margin:0;font-size:14px;line-height:1.5}' +
      '.stock-notify__body.is-success{color:#06971e}' +
      '.stock-notify__body.is-warning{color:#8a6100}' +
      '.stock-notify__body.is-error{color:#b91c1c}';
    document.head.appendChild(style);
  }

  function ensureModal() {
    if (modal) return modal;
    injectStyles();
    var t = texts();
    modal = document.createElement('div');
    modal.className = 'stock-notify';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-labelledby', 'stock-notify-title');
    modal.innerHTML =
      '<div class="stock-notify__box">' +
      '<button type="button" class="stock-notify__close" data-stock-notify-close></button>' +
      (t.logo ? '<img class="stock-notify__logo" alt="" width="120" height="40" src="">' : '') +
      '<p class="stock-notify__title" id="stock-notify-title"></p>' +
      '<p class="stock-notify__body" data-stock-notify-body></p>' +
      '</div>';
    var closeButton = modal.querySelector('[data-stock-notify-close]');
    closeButton.setAttribute('aria-label', t.close);
    closeButton.textContent = '×';
    if (t.logo) modal.querySelector('.stock-notify__logo').src = t.logo;
    modal.querySelector('.stock-notify__title').textContent = t.title;

    modal.addEventListener('click', function (event) {
      if (event.target === modal || event.target.closest('[data-stock-notify-close]')) closeModal();
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
    document.body.appendChild(modal);
    return modal;
  }

  function openModal(message, tone, title) {
    var el = ensureModal();
    el.querySelector('.stock-notify__title').textContent = title || texts().title;
    var body = el.querySelector('[data-stock-notify-body]');
    body.textContent = message;
    body.className = 'stock-notify__body is-' + tone;
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    el.querySelector('[data-stock-notify-close]').focus();
  }

  function closeModal() {
    if (!modal) return;
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* ---------------------------------------------------------------------- */
  /* İstek                                                                  */
  /* ---------------------------------------------------------------------- */

  // Ürün sayfasında ya da kart formunda seçili varyant; yoksa butondaki değer.
  function variantIdFor(button) {
    var form = button.closest('form');
    var input = form && form.querySelector('[name="id"]');
    return (input && input.value) || button.dataset.variant_id || '';
  }

  async function register(variantId, type) {
    var t = texts(type);
    var price = isPriceType(type);
    try {
      if (price) {
        await comnexusFetch(COMNEXUS_API.PRICE_DROP_NOTIFY, {
          body: { email: identity().email, shopifyProductVariantId: toVariantGid(variantId) }
        });
      } else {
        await comnexusFetch(COMNEXUS_API.LET_ME_KNOW, {
          body: { ShopifyProductVariantId: toVariantGid(variantId), Email: identity().email }
        });
      }
      openModal(t.success, 'success', t.title);
    } catch (error) {
      console.error('[stock-notify] request failed:', error);
      var isApi = error && error.code === 'api';
      if (price && isApi) {
        // succeeded:false → sunucunun mesajı ("Bu ürün için talebini daha önce aldık" vb.)
        var message = window.comnexusUserMessage ? comnexusUserMessage(error, t.already) : t.already;
        openModal(message, 'warning', t.title);
        return;
      }
      // Stok bildiriminde "succeeded: false" kayıt zaten var demek (Jumbo'daki anlamı).
      openModal(isApi ? t.already : t.error, isApi ? 'warning' : 'error', t.title);
    }
  }

  function savePending(variantId, type) {
    try {
      sessionStorage.setItem(
        PENDING_KEY,
        JSON.stringify({ variantId: String(variantId), type: type || 'InStock', path: window.location.pathname, at: Date.now() })
      );
    } catch (e) {
      /* sessionStorage kapalı: girişten sonra müşteri tekrar tıklar */
    }
  }

  function takePending() {
    try {
      var pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
      sessionStorage.removeItem(PENDING_KEY);
      if (!pending || Date.now() - pending.at > PENDING_TTL_MS) return null;
      return pending;
    } catch (e) {
      return null;
    }
  }

  async function openStockOutModal(button) {
    // Kart butonları type="submit": formun stoksuz ürünü sepete eklemesini engelle.
    var event = window.event;
    if (event && event.type === 'click') {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!button) return;
    if (button.getAttribute('aria-busy') === 'true') return;
    var type = button.dataset.button_type || 'InStock';

    var variantId = variantIdFor(button);
    if (!variantId) return;

    if (!identity()) {
      savePending(variantId, type);
      window.location.assign(
        '/account/login?return_url=' + encodeURIComponent(window.location.pathname + window.location.search)
      );
      return;
    }

    button.setAttribute('aria-busy', 'true');
    try {
      await register(variantId, type);
    } finally {
      button.removeAttribute('aria-busy');
    }
  }

  function peekPending() {
    try {
      var pending = JSON.parse(sessionStorage.getItem(PENDING_KEY) || 'null');
      if (!pending || Date.now() - pending.at > PENDING_TTL_MS) return null;
      return pending;
    } catch (e) {
      return null;
    }
  }

  function resumePending() {
    if (!identity() || typeof window.comnexusFetch !== 'function') return;
    var pending = peekPending();
    if (!pending) return;
    if (pending.path === window.location.pathname) {
      takePending();
      register(pending.variantId, pending.type);
      return;
    }
    // Giriş formu her zaman "/?new_login=true"ya döner; bekleyen kayıt varsa ürün sayfasına geri götür.
    if (/[?&]new_login=/.test(window.location.search)) {
      // Ana sayfadaki giriş sonrası sepet senkronu (hp-cart-sync) tamamlansın diye kısa gecikme.
      setTimeout(function () { window.location.assign(pending.path); }, 1200);
    }
  }

  window.openHollyNotificationStockOutModal = openStockOutModal;
  window.stockNotify = { open: openStockOutModal, close: closeModal };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', resumePending);
  } else {
    resumePending();
  }
})();
